<script lang="ts">
	import { onMount } from "svelte"

	let id = $state()
	let password = $state()

	onMount(() => {
		const params = new URLSearchParams(window.location.search)

		id = params.get("id")
		password = params.get("password")
	})
</script>

<div class="printable">
	ID: {id}
	<br />
	Password: <br />{password}
</div>
<button onclick={() => print()}>Print</button>

<style>
	.printable {
		padding-top: 0.5rem;
		text-align: center;
		line-height: 1.5em;
		width: fit-content;
		min-width: 14rem;
	}

	button {
		margin: 0.5rem;
	}

	@media print {
		button {
			display: none;
		}
	}
</style>
